// extracted by mini-css-extract-plugin
module.exports = {"blockContent":"styles__blockContent___2ZFGK"};